import OrderDocumentListItem from "@/models/api/orders/OrderDocumentListItem";

export default {
  items: [
    {
      id: "aaea5f96-ca3e-4bcb-b479-77d54ccc79d1",
      documentNumber: "7/01/2021/RZE",
      documentTypeName: "Faktura VAT",
      layout: "Standard", // null, Standard, Extended
      translationCulture: "pl-PL",
      saleDate: "2021-01-18T00:00:00",
      issueDate: "2021-01-18T00:00:00",
      receiptHasInvoice: false,
      canReprintDocument: true,
      canGenerateXMLFile: false,
    },
  ] as Array<OrderDocumentListItem>,
  generateDocumentsEnabled: false,
  generateProformaEnabled: false,
};
